import type { DocumentV1 } from '@lumapps/medias-document/types';

export interface Image {
    alt?: string;
    url?: string;
    blobUrl?: string;
    file?: File;
    name?: string;
    id?: string;
    rawMedia?: DocumentV1;
    originalImage?: Image;
    width?: number;
    height?: number;
}

export enum UPLOAD_IMAGE_OPTIONS {
    FROM_COMPUTER = 'upload-from-computer',
    /** WARNING: Only works on legacy context */
    FROM_LEGACY_MEDIA_LIBRARY = 'pick-from-legacy-media-library',
    FROM_MEDIA_LIBRARY = 'pick-from-media-library',
    WITH_AI = 'generate-with-ai',
}

interface BaseUploadImageOption {
    type: Exclude<UPLOAD_IMAGE_OPTIONS, UPLOAD_IMAGE_OPTIONS.FROM_MEDIA_LIBRARY>;
}

export interface SimpleUploadImageOption extends BaseUploadImageOption {
    /** Callback when an image have been selected
     * - image can be a picked File or an url
     * - Original picture is used for cropper dialog to keep modifications visible
     */
    onConfirm: (image: File, originalPicture?: { url: string; file?: File }) => void;
}

export interface MultipleUploadImageOption extends BaseUploadImageOption {
    /** Callback when images have been selected
     * - images can be a picked File or an url
     * - Original pictures are used for cropper dialog to keep modifications visible
     */
    onConfirm: (images: File[], originalPictures?: { url: string; file?: File }[]) => void;
}

export type UploadImageOption<IsMultiple extends boolean = false> = IsMultiple extends true
    ? MultipleUploadImageOption
    : SimpleUploadImageOption;

interface BaseFromFilePickerOption {
    type: UPLOAD_IMAGE_OPTIONS.FROM_MEDIA_LIBRARY;
}

export interface SimpleFromFilePickerOption extends BaseFromFilePickerOption {
    /** Callback when an image have been selected
     */
    onConfirm: (image?: DocumentV1) => void;
}

export interface MultipleFromFilePickerOption extends BaseFromFilePickerOption {
    /** Callback when images have been selected
     */
    onConfirm: (images?: DocumentV1[]) => void;
}

export type FromFilePickerOption<IsMultiple extends boolean = false> = IsMultiple extends true
    ? MultipleFromFilePickerOption
    : SimpleFromFilePickerOption;

export type UploadDialogImageOption<IsMultiple extends boolean = false> =
    | FromFilePickerOption<IsMultiple>
    | UploadImageOption<IsMultiple>;
